import { ProfileCompletionItem } from '@core/enums';

/**
 * Barra de progresso da completude do perfil
 */
export interface IProfileProgressBar {
  percent: number;
  currentStep: number;
  totalSteps: number;
}

/**
 * Seção/Nível de completude do perfil
 */
export interface IProfileCompletionLevel {
  level: number;
  items: ProfileCompletionItem[];
  notApplicableItems: ProfileCompletionItem[];
  completed: boolean;
}

/**
 * Resposta do endpoint Score de Perfil do Cliente
 * Nivel 1 - Personal Data
 * Nivel 2 - Contact Details
 * Nivel 3 - Vehicle
 * Nivel 4 - Car Connected Dealer
 */
export interface IProfileScoreResponse {
  progressBar: IProfileProgressBar;
  personalData: IProfileCompletionLevel;
  contactDetails: IProfileCompletionLevel;
  vehicle: IProfileCompletionLevel;
  carConnectedDealer: IProfileCompletionLevel;
  completeRegistration: boolean;
}
